import { AuthContext } from 'contexts/AuthContext';
import { useContext } from 'react';
import PlacementChart from '../components/PlacementChart';
import SchoolFeesChart from '../components/SchoolFeesChart';
import RecentAssignments from '../components/RecentAssignments';
import AnnouncementsCard from 'pages/Announcement/AnnouncementsCard';

const Index = () => {
  const { state } = useContext(AuthContext);
  return (
    <div className="mt-3 flex h-full w-full flex-col gap-[20px] rounded-[20px] xl:flex-row">
      <div className="h-full w-full rounded-[20px]">
        {/* left side */}
        <div className="col-span-9 h-full w-full rounded-t-2xl xl:col-span-6">
          <AnnouncementsCard />
          {/* overall & Balance */}
          <div className="mb-5 grid grid-cols-6 gap-5">
            <div className="col-span-6 h-full w-full rounded-xl 3xl:col-span-4">
              <PlacementChart />
            </div>
            {(state?.user?.role == 'admin' ||
              state?.user?.role == 'superadmin' ||
              state?.user?.role == 'Admin' ||
              state?.user?.role == 'Superadmin') && (
              <div className="col-span-6 w-full 3xl:col-span-2">
                <SchoolFeesChart />
              </div>
            )}
          </div>
          <div className="mb-5 w-full">
            <RecentAssignments />
          </div>
          {/* Daily Traffic and.. */}
          <div className="mt-5 grid w-full grid-cols-6 gap-5"></div>
        </div>
      </div>

      {/* line */}
      {/* <div className="flex w-0 bg-gray-200 dark:bg-navy-700 xl:w-px" /> */}

      {/* right section */}
      {/* <div className="h-full w-full xl:w-[400px] xl:min-w-[300px] 2xl:min-w-[400px]"></div> */}
    </div>
  );
};

export default Index;
